// import React from "react";
// import ProductWrap from "../../Mescomposants/Product/ProductWrap";
// import { Link } from "react-router-dom";

// const ProductCarousel = ({ products, sectionTitle, imagelBaseUrl, titleLink }) => {
//     return (
//         <div>
//             <h2 className="mb-4 sectionTitle">
//                 {titleLink ? (
//                     <Link to={titleLink} style={{ textDecoration: "none", color: "inherit" }}>
//                         {sectionTitle} 
//                     </Link>
//                 ) : (
//                     sectionTitle
//                 )}
//             </h2>
//             <div
//                 className="d-flex"
//                 style={{
//                     width: "100%",
//                     overflowX: "auto",
//                     overflowY: "hidden",
//                     whiteSpace: "nowrap",
//                     position: "relative",
//                     paddingBottom: "20px",
//                 }}
//             >
//                 <div className="d-flex justify-content-center" style={{ gap: "20px" }}>
//                     {products?.map((product) => (
//                         <ProductWrap key={product.ArtID} product={product} />
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ProductCarousel; // ceci marche 10/04/2026


import React from "react";
import ProductWrap from "../../Mescomposants/Product/ProductWrap";
import { Link } from "react-router-dom";

const ProductCarousel = ({ products, sectionTitle, imagelBaseUrl, titleLink, userData, onSuccess }) => {
    return (
        <div style={{ marginBottom: "40px" }}>
            {/* Titre + lien "Voir plus" */}
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
            }}>
                <h2 className="sectionTitle" style={{ margin: 0 }}>
                    {sectionTitle}
                </h2>

                {titleLink && (
                    <Link
                        to={titleLink}
                        style={{
                            color: "#214293",
                            fontWeight: "600",
                            fontSize: "1.2rem",
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            border: "1px solid #214293",
                            padding: "6px 14px",
                            borderRadius: "20px",
                            transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = "#214293";
                            e.currentTarget.style.color = "white";
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = "transparent";
                            e.currentTarget.style.color = "#214293";
                        }}
                    >
                        En savoir plus →
                    </Link>
                )}
            </div>

            {/* Grille de produits */}
            {products && products.length > 0 ? (
                <div style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    gap: "20px",
                    justifyContent: "flex-start",
                    overflowX: "auto",
                    overflowY: "hidden",
                    paddingBottom: "15px",
                    WebkitOverflowScrolling: "touch"
                }}>
                    {products.map((product) => (
                        <div key={product.ArtID} style={{ flex: "0 0 auto" }}>
                            <ProductWrap
                                product={product}
                                userData={userData}
                                onSuccess={onSuccess}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                <div /*style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#888",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "10px",
                }}*/ >
                    {/* <p>Aucun produit disponible pour le moment.</p> */}
                </div>
            )}
        </div>
    );
};

export default ProductCarousel;